class ProductSwiper extends HTMLElement {
  constructor() {
    super();

    this.touchstartX = 0;
    this.touchendX = 0;
    this.touchScroll = 0;
    this.slider = this.querySelector("slideswiper");
    this.slides = this.querySelectorAll("slide");
    this.prevButton = this.querySelector("previous button");
    this.nextButton = this.querySelector("next button");
    this.currentIndex = 0;
    this.slideCount = this.slides.length;
  }
  connectedCallback() {
    this.querySelector("previous").classList.add("fadeout");
    this.querySelector("next").classList.add("fadeout");

    this.setupEventListeners();
  }
  setupEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener("click", () => this.prevSlide());
    }
    if (this.nextButton) {
      this.nextButton.addEventListener("click", () => this.nextSlide());
    }
    if (this.slider) {
      this.slider.addEventListener(
        "touchstart",
        (event) => {
          this.touchstartX = event.changedTouches[0].screenX;
        },
        false
      );
      this.slider.addEventListener(
        "touchend",
        (event) => {
          this.touchendX = event.changedTouches[0].screenX;
          this.touchScroll = this.touchstartX - this.touchendX;
          if (this.touchScroll < 70 && this.touchScroll > -70) {
            this.touchScroll = 0;
          }
          if (this.touchendX < this.touchstartX && this.touchScroll != 0) {
            this.nextSlide();
          }
          if (this.touchendX > this.touchstartX && this.touchScroll != 0) {
            this.prevSlide();
          }
        },
        false
      );
    }
  }
  prevSlide() {
    this.goToSlide((this.currentIndex - 1 + this.slideCount) % this.slideCount);
  }
  nextSlide() {
    this.goToSlide((this.currentIndex + 1) % this.slideCount);
  }
  goToSlide(index) {
    // Update slides
    //this.slides[this.currentIndex].classList.remove('active');
    let activeSlide = this.slides[this.currentIndex];
    activeSlide.classList.remove("active");
    this.slides[index].classList.add("active");
    this.currentIndex = index;
  }
}

customElements.define("product-slideshow", ProductSwiper);
